<ng-container [formGroup]="formGroup">
  <lds-percent-input
    formControlName="percent"
    [label]="label"
    [isRequired]="isRequired"
    [showHighlight]="showHighlight"
    [min]="0"
    [max]="100"
    [decimals]="2"
    [validations]="validations">
  </lds-percent-input>
</ng-container>
